<template>
  <v-card class="card-pad">
    <h2 class="text-center my-2">Métrica de Calibração</h2>

    <v-form ref="form">
      <v-row class="ma-0">
        <v-col cols="12">
          <label>Nome</label>
          <v-text-field
            v-model="metric.name"
            :loading="metricLoading"
            outlined
            placeholder="Digite o nome da métrica"
            class="primary-input"
            hide-details="auto"
            :rules="[(v) => !!v || 'Nome obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12">
          <label>Unidade</label>
          <v-text-field
            v-model="metric.unit"
            :loading="metricLoading"
            outlined
            placeholder="Digite o unidade da métrica"
            class="primary-input"
            hide-details="auto"
            :rules="[(v) => !!v || 'Unidade obrigatório']"
          ></v-text-field>
        </v-col>

        <v-col cols="12" class="d-flex">
          <v-btn
            class="ma-0"
            color="#B14949"
            depressed
            dark
            style="border-radius: 12px"
            @click="$emit('close')"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="primary-button ma-0"
            dark
            :disabled="metricLoading"
            :loading="loading"
            @click="submit"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'CalibrationV2MetricManage',

  props: {
    metricId: Number,
  },

  data() {
    return {
      loading: false,
      metricLoading: false,
      metric: {},
      isEditing: false,
      apiService: new ApiService(),
    }
  },

  created() {
    if (this.metricId) {
      this.isEditing = true
      this.getMetric()
    }
  },

  methods: {
    getMetric() {
      this.metricLoading = true
      this.apiService
        .get(`calibration/v2/metric/${this.metricId}`)
        .then((response) => {
          this.metric = response.content
          this.metricLoading = false
        })
        .catch(() => {
          this.metricLoading = false
        })
    },

    add() {
      this.loading = true

      this.apiService
        .post('calibration/v2/metric', this.metric)
        .then((response) => {
          this.loading = false
          this.$toast.success('Métrica salva! 📏')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true

      this.apiService
        .put('calibration/v2/metric', this.metric)
        .then((response) => {
          this.loading = false
          this.$toast.success('Métrica salva! 📏')
          this.$emit('confirm')
        })
        .catch(() => {
          this.loading = false
        })
    },

    submit() {
      if (!this.$refs.form.validate()) return

      if (this.isEditing) {
        this.edit()
      } else {
        this.add()
      }
    },
  },
}
</script>

<style></style>
